import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";
import { I18nProvider, SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n";
import ar from "@/i18n/ar.json";
import en from "@/i18n/en.json";

const dictionaries = { ar, en };

function LangShell() {
  const { lang } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (!SUPPORTED_LANGS.includes(lang)) return;
    document.documentElement.setAttribute("lang", lang === "ar" ? "es-AR" : "en");
    const dict = dictionaries[lang];
    if (dict?.meta?.title) document.title = dict.meta.title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc && dict?.meta?.description) {
      desc.setAttribute("content", dict.meta.description);
    }
  }, [lang, location.pathname]);

  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }

  return (
    <I18nProvider lang={lang}>
      <div className="flex min-h-screen flex-col bg-white">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route index element={<Home />} />
            <Route
              path="privacy-policy"
              element={
                <LegalPage contentKey="privacy" testId="page-privacy" />
              }
            />
            <Route
              path="cookie-policy"
              element={
                <LegalPage contentKey="cookiePolicy" testId="page-cookies" />
              }
            />
            <Route
              path="terms"
              element={<LegalPage contentKey="terms" testId="page-terms" />}
            />
            <Route path="*" element={<Navigate to={`/${lang}`} replace />} />
          </Routes>
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

function ThankYouShell() {
  useEffect(() => {
    document.documentElement.setAttribute("lang", "es-AR");
    document.title = "Gracias · Vivendario";
  }, []);
  return (
    <I18nProvider lang="ar">
      <div className="flex min-h-screen flex-col bg-white">
        <Header />
        <div className="flex-1">
          <ThankYou />
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        <Route path="/thank_you" element={<ThankYouShell />} />
        <Route path="/:lang/*" element={<LangShell />} />
        <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
